<template>
  <div>
    <v-text-field
      v-model="company.custom_properties.theme.primaryColor"
      :color="company.custom_properties.theme.primaryColor"
      :label="$t('screener.save.form.theme_primary_color')"
      placeholder="Hex code e.g #FF0000"
    >
      <template v-slot:append>
        <InputColorPicker v-model="company.custom_properties.theme.primaryColor" />
      </template>
    </v-text-field>

    <v-text-field
      v-model="company.custom_properties.theme.secondaryColor"
      :color="company.custom_properties.theme.secondaryColor"
      :label="$t('screener.save.form.theme_secondary_color')"
      placeholder="Hex code e.g #FF0000"
    >
      <template v-slot:append>
        <InputColorPicker  v-model="company.custom_properties.theme.secondaryColor" />
      </template>
    </v-text-field>

    <v-text-field
      v-model="company.custom_properties.theme.backgroundColor"
      :color="company.custom_properties.theme.backgroundColor"
      :label="$t('screener.save.form.theme_background_color')"
      placeholder="Hex code e.g #FF0000"
    >
      <template v-slot:append>
        <InputColorPicker  v-model="company.custom_properties.theme.backgroundColor" />
      </template>
    </v-text-field>
    <v-switch
      v-model="company.custom_properties.is_rtl"
      :label="$t('screener.save.form.theme.rtl')"
      color="saPrimary"
      value="true"
    ></v-switch>
    <v-switch
      v-model="company.show_company_branding"
      :label="$t('screener.save.form.theme.show_company_branding')"
      color="saPrimary"
      :value="1"
    ></v-switch>
  </div>
</template>

<script>
import InputColorPicker from 'vue-native-color-picker';

export default {
  name: "AdminCompanyProfileTheme",
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  components: {
    InputColorPicker
  },
  watch: {
    company: {
      handler: function () {
        this.$emit("update:company", this.company);
      },
      deep: true,
    },
  }
};
</script>

<style>
</style>
